module.exports = __webpack_public_path__ + "static/media/start.1ddb9c5d.mp3";